import app from 'flarum/forum/app';

/**
 * Staff-only download stats, from the mirror's GitHub release.
 *
 * ponytail: a module-level promise, not a store. The numbers are a read-only
 * staff curiosity that nothing else depends on, so one in-flight request per
 * page load is the whole caching story; the server already caches the GitHub
 * round trip for an hour.
 */
let pending = null;

const EMPTY = { counts: {}, windows: {} };

export function isStaff() {
  return !!app.forum.attribute('chdkCamerasStaff');
}

export function downloadStats() {
  if (!isStaff()) return Promise.resolve(EMPTY);

  if (!pending) {
    pending = app
      .request({ method: 'GET', url: app.forum.attribute('apiUrl') + '/chdk-cameras/downloads' })
      .then((res) => ({ counts: res.counts || {}, windows: res.windows || {} }))
      // no numbers is a fine outcome; a broken page is not
      .catch(() => EMPTY);
  }

  return pending;
}

export function downloadCounts() {
  return downloadStats().then((data) => data.counts);
}
